export default "__VITE_ASSET__DBl$9K7O__"